<template>
  <header-menu class="discover-menu" event-name="header-20200624-discover_menu" id="discover" :modifiers="['full']">
    <div class="discover-menu__menu">
      <div class="discover-menu__container">
        <div class="discover-menu__header">
          <h3 class="discover-menu__headline" v-html="$t('headline')" />
        </div>
        <ul class="discover-menu__categories">
          <li v-for="category in availableCategories" class="discover-menu__category" :key="category.id">
            <a class="discover-menu__category-link" :href="category.url">
              <sprite class="discover-menu__sprite" :id="`category/${category.sprite}`" />
              <span class="discover-menu__label" v-html="category.title" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </header-menu>
</template>

<script>
import { mapGetters } from "vuex"
import HeaderMenu from "./header-menu"
import Sprite from "@/shared/sprite"

export default {
  name: "DiscoverMenu",
  components: {
    HeaderMenu,
    Sprite
  },
  computed: {
    ...mapGetters("content", ["availableCategories"]),
    ...mapGetters(["isUserLoggedIn"])
  },
  watch: {
    isUserLoggedIn: function () {
      // We need to reload the component when the user is logged in to fetch blocked categories
      this.$store.dispatch("content/loadAvailableCategories")
    }
  },
  mounted() {
    this.$store.dispatch("content/loadAvailableCategories")
  },
  i18n: {
    messages: {
      en: {
        headline: "Explore by category"
      },
      de: {
        headline: "Kategorien entdecken"
      },
      es: {
        headline: "Explora por categoría"
      }
    }
  }
}
</script>

<style lang="scss">
.discover-menu {
  position: static;

  &__menu {
    padding-top: $spacing-32;
    padding-bottom: $spacing-64 - $spacing-24;

    background-color: $pale-mint-grey;
  }

  &__container {
    @include container;
  }

  &__header {
    display: flex;
    margin-bottom: $spacing-32;
    padding-bottom: $spacing-24;

    border-bottom: $light-grey solid 1px;
  }

  &__headline {
    @include font-style(subheadline, $color: $blue);

    margin: 0 $spacing-96 0 0;
  }

  &__categories {
    @include grid-css;
  }

  &__category {
    @include grid-css-element(
      (
        m: 6,
        l: 4
      )
    );

    margin-bottom: $spacing-24;
  }

  &__category-link {
    display: flex;
    align-items: center;

    color: $midnight;

    &:hover {
      color: $blue;
    }
  }

  &__sprite {
    margin-right: $spacing-16;
  }

  &__label {
    @include font-style(p, $color: inherit);
  }

  @include media(max-width, m) {
    display: none;
  }
}
</style>
